import classnames from "classnames";
import React from "react";
import { Check } from "../../assets/icons/icons";
import SVGIcon from "../svg-icon/svg-icon";
import { CheckboxStyle, colors } from "./checkbox-style";

export interface ICheckboxProps {
  children?: any;
  onChange?: any;
  onBlur?: any;
  onFocus?: any;
  onKeyDown?: any;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  message?: string;
  errorMessage?: string;
  tooltip?: string;
  name?: string;
  checked?: boolean;
  className?: string;
  isRadio?: boolean;
  indeterminated?: boolean;
  inSelect?: boolean;
}

// States: disable | active | error

export const Checkbox: React.FC<ICheckboxProps> = (props: ICheckboxProps) => {
  const [checked, setChecked] = React.useState<boolean>(false);

  const handleChange = (ev: any) => {
    if (props.onChange) {
      props.onChange(ev);
    } else if (props.checked === undefined) {
      setChecked(ev.target.checked);
    }
  };

  const check = props.checked || checked;

  return (
    <CheckboxStyle
      className={classnames(props.className || "", {
        error: !!props.error,
        disabled: !!props.disabled,
        required: !!props.required,
        active: !!check,
        radio: props.isRadio,
        indeterminated: props.indeterminated,
        "in-select": props.inSelect,
      })}
    >
      <label className="checkbox-container">
        <input
          type="checkbox"
          name={props.name}
          disabled={props.disabled}
          required={props.required}
          checked={props.checked || checked}
          onChange={(ev: any) => !props.disabled && handleChange(ev)}
          onFocus={(ev: any) =>
            !props.disabled && props.onFocus && props.onFocus(ev)
          }
          onBlur={(ev: any) =>
            !props.disabled && props.onBlur && props.onBlur(ev)
          }
          onKeyDown={(ev: any) =>
            !props.disabled && props.onKeyDown && props.onKeyDown(ev)
          }
        />
        <div className="checkbox-item">
          {!props.isRadio && check ? (
            <div className="checkbox-ite__icon">
              <SVGIcon
                icon={Check}
                color={colors.bn.white}
                size={props.inSelect ? "16px" : "24px"}
              />
            </div>
          ) : (
            <div className="checkbox-item__circle" />
          )}
        </div>
        {props.children && (
          <div className="checkbox-label">{props.children}</div>
        )}
        <div className="checkbox-bottom">
          {props.errorMessage && (
            <div className="checkbox-bottom-error">
              <p>{props.errorMessage}</p>
            </div>
          )}
          {props.message && (
            <div className="checkbox-bottom-message">
              <p>{props.message}</p>
            </div>
          )}
        </div>
      </label>
    </CheckboxStyle>
  );
};
